<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Navbar from "../components/Navbar.svelte";
  import { user } from "../stores/user";
  import { BASE_URL } from "../stores/BASE_URL";
  import CardContent from "../components/CardContent.svelte";

  let clientes = [];
  let cliente = "0";
  let acciones = false;

  let isLoading = false;

  let temp_archivo = [];

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`);
    const resp = await response.json();
    clientes = resp.data;
  };

  getClientes();

  const updateCliente = () => {
    temp_archivo.forEach((obj) => {
      obj.id_cliente = cliente;
    });
  };

  const cargarUsuarios = async () => {
    console.log(temp_archivo);
    isLoading = true;

    let post_data = { data: temp_archivo, action: "uploadUsuarios" };

    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: JSON.stringify(post_data),
      headers: {
        "Content-Type": "aplication/json",
      },
    });

    const resp = await response.json();
    if (resp.status == "success") {
      alert("usuarios cargados");
      //navigate(`/usuarios`, { replace: true })
    } else {
      alert(resp.message);
    }

    isLoading = false;
  };

  //Leer documentos
  const leerArchivo = (e) => {
    temp_archivo = [];
    let tmp_txt = [];
    let archivo = e.target.files[0];
    let lector = new FileReader();
    if (!archivo) {
      return;
    }
    lector.onload = (e) => {
      let contenido = e.target.result;
      contenido = contenido.split("\r\n");
      contenido.map(function (item) {
        let tabs = item.split("\t");
        if (tabs[0] !== undefined && tabs[0] !== "") {
          let col = {
            id_cliente: cliente,
            usuario: tabs[0],
            clave: tabs[1],
            tipo_documento: tabs[2],
            documento: tabs[3],
            nombres: tabs[4],
            inicio: tabs[5],
            fin: tabs[6],
            consultas_contrato: tabs[7],
            consultas: tabs[7],
            consumo: 0,
            estado: tabs[8],
          };
          tmp_txt.push(col);
        }
      });
      const dataArr = new Set(tmp_txt);
      temp_archivo = [...dataArr];
    };
    lector.readAsText(archivo);
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true;
    }
  });
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Cargar usuarios">
      <div class="row g-2 align-items-center">
        <div class="col-auto">
          <label for="cliente">Cliente</label>
        </div>
        <div class="col-auto">
          <select class="form-select" bind:value={cliente} on:change={updateCliente}>
            <option value="0">SELECCIONE UN CLIENTE</option>
            {#each clientes as cliente}
              <option value={cliente.id}>{cliente.razon_social}</option>
            {/each}
          </select>
        </div>
        <div class="col-auto">
          <div class="input-group">
            <input type="file" class="form-control" aria-label="Upload" id="formFile" on:change={(e) => leerArchivo(e)} />
          </div>
        </div>
        <div class="col-auto">
          {#if temp_archivo.length > 0 && cliente != "0"}
            <button class="btn btn-primary" on:click={cargarUsuarios}> Cargar usuarios </button>
          {:else if isLoading}
            <button class="btn btn-primary" disabled>Cargando...</button>
          {:else}
            <button class="btn btn-primary" disabled>Cargar usuarios</button>
          {/if}
        </div>
        <div class="col-auto">
          <small>
            Archivo <b>.txt</b> formato <b>UTF-8</b> delimitado por tabulaciones: (usuario, clave, tipo_documento = "DNI/CARNET EXT.", documento, nombres, inicio, fin, consultas,
            estado = "1 = Activo, 0 = Inactivo") sin encabezado.
          </small>
        </div>
      </div>

      {#if temp_archivo.length > 0}
        <div class="table-responsive mt-3">
          <table class="table table-sm table-striped table-bordered small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th>Usuario</th>
                <th>Clave</th>
                <th>Tipo Doc.</th>
                <th>Documento</th>
                <th>Nombres</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Consultas</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {#each temp_archivo as row}
                <tr>
                  <td>{row.usuario}</td>
                  <td>{row.clave}</td>
                  <td>{row.tipo_documento}</td>
                  <td>{row.documento}</td>
                  <td>{row.nombres}</td>
                  <td>{row.inicio}</td>
                  <td>{row.fin}</td>
                  <td class="text-end">{Number(row.consultas).toLocaleString("es-PE")}</td>
                  <td
                    >{#if row.estado == "1"}
                      <small class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2">
                        Activo
                      </small>
                    {:else}
                      <small class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2">
                        Inactivo
                      </small>
                    {/if}</td
                  >
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      {/if}
    </CardContent>
  </div>
{/if}
